import type * as ShowLoyaltyDialog from '@ori-events/show-loyalty-dialog';
import { useContext, createContext } from 'react';

const DEFAULT_CONTEXT_DATA = {
  catalogueItemId: '0',
  choiceId: 0,
  consultantPrice: 0,
  itemCode: '0',
  loyaltyPoints: 0,
  loyaltyPrice: 0,
  productName: 'none',
  quantity: 0,
};

export const appContext = createContext<ShowLoyaltyDialog.Data>(DEFAULT_CONTEXT_DATA);

export const AppContextProvider = appContext.Provider;

export const useAppContext = () => useContext(appContext);
